import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaHome, FaDownload } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [countdown, setCountdown] = useState(5);
    const [userData, setUserData] = useState(null);

    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('user_id');

    useEffect(() => {
        // Fetch user data if needed
        if (userId) {
            // You can fetch user details here if needed
            console.log('Payment successful for user:', userId);
        }

        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    navigate('/');
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate, userId]);

    const handleDownloadReceipt = () => {
        const receipt = `
            BIHEBARI MATRIMONY - PAYMENT RECEIPT
            ====================================
            User ID: ${userId}
            Amount: Rs. 4,000
            Payment Status: Successful
            Date: ${new Date().toLocaleString()}
            ====================================
            Thank you for registering with Bihebari Matrimony!
        `;
        
        const blob = new Blob([receipt], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `receipt_${userId}.txt`;
        a.click();
        URL.revokeObjectURL(url);
        toast.success('Receipt downloaded');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-indigo-100 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                <div className="mb-6">
                    <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                        <FaCheckCircle className="text-green-500 text-5xl" />
                    </div>
                </div>
                
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Payment Successful!</h1>
                <p className="text-gray-600 mb-6">
                    Your registration has been completed successfully.
                </p>
                
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <div className="flex justify-between mb-2">
                        <span className="text-gray-600">User ID:</span>
                        <span className="font-semibold">BB{userId}</span>
                    </div>
                    <div className="flex justify-between mb-2">
                        <span className="text-gray-600">Amount Paid:</span>
                        <span className="font-semibold text-green-600">Rs. 4,000</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-600">Payment Status:</span>
                        <span className="font-semibold text-green-600">Completed</span>
                    </div>
                </div>
                
                <div className="space-y-3">
                    <button
                        onClick={handleDownloadReceipt}
                        className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition flex items-center justify-center space-x-2"
                    >
                        <FaDownload />
                        <span>Download Receipt</span>
                    </button>
                    
                    <button
                        onClick={() => navigate('/')}
                        className="w-full bg-gray-500 text-white py-2 rounded-lg hover:bg-gray-600 transition flex items-center justify-center space-x-2"
                    >
                        <FaHome />
                        <span>Go to Home</span>
                    </button>
                </div>
                
                <p className="text-sm text-gray-500 mt-6">
                    Redirecting to home in {countdown} seconds...
                </p>
            </div>
        </div>
    );
};

export default PaymentSuccess;